var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 2.2c-.8-.8-2-.8-2.8 0L5 11.8c-.8.8-.8 2 0 2.8s2 .8 2.8 0L14 8.4v20c0 1.2.8 2 2 2s2-.8 2-2v-20l6.2 6.2c.8.8 2 .8 2.8 0s.8-2 0-2.8c.2 0-9.6-9.6-9.6-9.6"
  })));
};
export default SvgArrowUp;